import { Router } from "@angular/router";
import { AuthService } from "app/services/auth.service";
import { RoutingService } from "app/services/routing.service";
import { inject } from "@angular/core";
import { ThemeService } from "@app/services/theme.service";
import { RuntimeConfigService } from "@app/services/runtime-config.service";

export async function initalizer(
  router: Router,
  authService: AuthService,
  routingService?: RoutingService,
  themeService?: ThemeService,
  runtimeConfigService?: RuntimeConfigService,
): Promise<void> {
  const runtimeConfig = runtimeConfigService ?? inject(RuntimeConfigService);
  await runtimeConfig.load();

  if (themeService) {
    themeService.initOnAppStart();
  }

  const fullUrl = document.location.href;
  const url = new URL(fullUrl);
  let token = url.searchParams.get('token');
  if (token) {
    authService.setAuthToken(token);
    localStorage.setItem('GeneXToken', token);
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      authService.setUser(JSON.parse(storedUser));
    }
    router.navigate([], {
      queryParams: { token: null },
      queryParamsHandling: 'merge'
    });
  } else {
    token = localStorage.getItem('GeneXToken');
    if (token) {
      authService.setAuthToken(token);
    }
    const user = localStorage.getItem('user');
    if (user) {
      authService.setUser(JSON.parse(user));
    }
  }

  if (!authService.getUser() && authService.getAuthToken()) {
    try {
      const data = await authService.signInWithCustomToken();
      if (data?.success && data?.user) {
        authService.setUser(data.user);
        localStorage.setItem('user', JSON.stringify(data.user));
        if (data.token) {
          authService.setAuthToken(data.token);
          localStorage.setItem('GeneXToken', data.token);
        }
      }
    } catch {
      // signInWithCustomToken failed; fall through to login redirect
    }
  }

  if (!authService.isLoggedIn()) {
    window.location.href = '/dashboard/#/login';
    return;
  }

  // 初始化路由服务并生成路由
  if (routingService) {
    await routingService.initOnAppStart();
  } else {
    // 如果没有传入routingService，使用inject作为备选方案
    const injectedRoutingService = inject(RoutingService);
    await injectedRoutingService.initOnAppStart();
  }
}